import React, { useState, useEffect } from 'react'
import OrderDetailMobile from './OrderDetailMobile'
import OrderDetailDesktop from './OrderDetailDesktop'

type FileItem = { 
  name: string
  size?: string
  type?: string
}

type Props = {
  title: string
  previewUrl?: string
  details: React.ReactNode[]
  processingTypes: string[]
  files: FileItem[]
  quantity?: number
  status?: string
  orderId: string
  // Информация о поданной цене
  submittedPrice?: number
  submittedDeliveryTime?: number
  submittedComment?: string
  priceFormatted?: string
  deliveryTimeFormatted?: string
  // Информация об отказе
  rejectedReason?: string
  rejectedAt?: string
  rejectedCompanyName?: string
  // Информация о подтверждении
  confirmationState?: 'pending' | 'accepted' | 'declined' | 'modified' | null
  showConfirmationCard?: boolean
  // Информация о дедлайне
  deadlineFormatted?: string
  deadlineStatus?: string
  deadlineCssClass?: string
  daysRemaining?: number
  // actions
  onDownloadFile?: (filename: string) => void
  onDownloadAll?: () => void
  onTake?: () => void
  onReject?: () => void
  onRestore?: () => void
  onSubmitPrice?: () => void
  onEditPrice?: () => void
  onComplete?: () => void
  onDefect?: () => void
  onFix?: () => void
  onBack?: () => void
  onPreviewFile?: (filename: string) => void
  // Обработчики подтверждения
  onAcceptConfirmation?: () => void
  onRequestPriceChange?: () => void
}

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      // Проверяем ширину экрана и user agent
      const width = window.innerWidth
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
      const isMobileWidth = width < 768 // Tailwind md breakpoint
      
      setIsMobile(isMobileUA || isMobileWidth)
    }

    // Проверяем при загрузке
    checkIsMobile()

    // Слушаем изменения размера окна
    window.addEventListener('resize', checkIsMobile)
    
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  return isMobile
}

export const OrderDetailAdaptive: React.FC<Props> = (props) => {
  const isMobile = useIsMobile()

  // Показываем мобильную версию на мобильных устройствах и узких экранах
  if (isMobile) {
    return <OrderDetailMobile {...props} />
  }

  // Показываем десктопную версию на широких экранах
  return <OrderDetailDesktop {...props} />
}

export default OrderDetailAdaptive
